<div [class]="'navbar-item ' + direction" [class.active]="active" [class.with-subheader]="subHeader">
  <div class="d-flex align-items-center header">{{header?.toUpperCase()}}<i *ngIf="multi" class="ms-2 al-icon al-ico-dropdown-arrow sm"></i></div>
  <div *ngIf="subHeader" class="sub-header">{{subHeader}}</div>
</div>
